module.exports = __webpack_public_path__ + "img/succeed.ebba64c6.png";